const BannerContainerM = ({ title, content }) => {
    return (
        <div className={'md:hidden bg-black-grey h-[300px] w-full flex flex-col gap-y-1 justify-center p-[134px_24px_112px_24px]'}>
            <span className={'text-22px font-bold text-white'}>{ title }</span>
            <span className={'text-16px font-medium text-white'}>{ content }</span>
        </div>
    );
}

export default BannerContainerM;